import React from 'react'
import classes from './styles/style.module.css';
import { CiLock } from "react-icons/ci";
import { useNavigate } from 'react-router-dom';

const HubbleMap = () => {
    const navigate = useNavigate();
    return (
        <div className={classes.mapPageContainer} style={{ backgroundImage: `url('/images/hubble/hubbleMapBg.jpg')`, backgroundSize: '100%' }} >
            <img src='/images/hubble/mapRoad.png' className={classes.mapRoad} />
            <img src='/images/hubble/starship.png' className={classes.starship} />
            <img src='/images/hubble/earth.png' className={classes.earth} />
            <img src='/images/hubble/saturn.png' className={classes.saturn} />
            <img src='/images/hubble/planet.png' className={classes.planet} />
            <div className={`${classes.level} ${classes.level1}`} onClick={() => navigate('/hubble/upload')} >
                <p>انتخابی</p>
                <div>1</div>
            </div>
            <div className={`${classes.level} ${classes.level2}`}>
                <p>مقدماتی</p>
                <div className={classes.lock}><CiLock /></div>
            </div>
            <div className={`${classes.level} ${classes.level3}`}>
                <p>نیمه نهایی</p>
                <div className={classes.lock}><CiLock /></div>
            </div>
            <div className={`${classes.level} ${classes.level4}`}>
                <p>نهایی</p>
                <div className={classes.lock}><CiLock /></div>
            </div>
            <div className={classes.mapBg}>
                <img src='/images/hubble/cloudes.png' className={classes.cloudes} />
                <img src='/images/hubble/sun.png' className={classes.sun} />
            </div>
        </div>
    )
}

export default HubbleMap